import { cwslapi } from "../index";

// 获取充值页面的充值排行
export const getRechargeRankApi = (data) => { 
  return cwslapi({
    url: "/recharge/getRechargeRank",
    method: "post",
    data,
  });
};



// 获取充值列表 —— 充值管理
export const getRechargeListApi = (data) => { 
  return cwslapi({
    url: "/recharge/getRechargeList",
    method: "post",
    data,
  });
};


// 发起支付 —— 充值管理
export const getdoPayApi = (data) => { 
  return cwslapi({
    url: "/recharge/doPay",
    method: "post",
    data,
  });
};


// 查询订单充值状态
export const getcheckOrderApi = (data) => { 
  return cwslapi({
    url: "/recharge/checkOrder",
    method: "post",
    data,
  });
};